"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var CarouselItem = function (props) { return (react_1.jsx(layout_1.Flex, __assign({ alignItems: "center", justifyContent: "center", css: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    } }, props))); };
exports.default = CarouselItem;
